// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__31cSU","label":"Completed_label__2kjxI"};